import { render, staticRenderFns } from "./TatEditor.vue?vue&type=template&id=7144f61e&"
import script from "./TatEditor.vue?vue&type=script&lang=js&"
export * from "./TatEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports